<template>
  <q-toolbar
    v-if="showBar && (hasProducts || alwaysShown)"
    id="footer-total-toolbar"
    :data-test="CypressTarget('TicketsTotalToolbar')"
    :color="SET_COLOR.primary"
    class="footer-bar"
  >
    <q-toolbar-title
      v-if="hasProducts"
      :data-test="CypressTarget('Title')"
      class="footer-title"
    >
      <div class="SimpleLine">
        {{ isFreeSale ? `${$t('label.total')}:` : '' }}
        {{ totalPrice }}
        <span
          v-if="labelSubTitle"
          slot="subtitle"
          v-text="labelSubTitle"
        />
      </div>
    </q-toolbar-title>
    <buy-button
      v-if="hasProducts"
      v-track-click:button="{category: 'Navegação', label: 'Comprar e Ir para Carrinho'}"
      :free-sale="isFreeSale"
      :disable="loading"
      :color="SET_COLOR.buttons.buy"
      :text-color="SET_COLOR_BUTTON.text.buy"
      :flat="SET_COLOR_BUTTON.flat.buy"
      @addToCart="$emit('addToCart')"
    />
    <transparent-fill-button v-else />
  </q-toolbar>
</template>

<script>
  import BuyButton from 'components/button/checkout/buyButton';
  import TransparentFillButton from 'components/button/common/transparentFill';
  import formatMoney from 'helpers/formatters/money';

  export default {
    name: 'ProductTotalSimpleToolBar',
    components: { TransparentFillButton, BuyButton },
    props: {
      showBar: {
        type: Boolean,
        default: true,
      },
      purchaseTotal: {
        type: Number,
        required: true,
      },
      purchaseItems: {
        type: Number,
        required: true,
      },
      alwaysShown: {
        type: Boolean,
        required: false,
        default: false,
      },
      labelSubTitle: {
        type: String,
        required: false,
        default: '',
      },
      loading: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    computed: {
      totalPrice() {
        return (this.purchaseTotal > 0)
          ? formatMoney(this.purchaseTotal, this.SET_LANGUAGE, this.SET_MONEY)
          : this.$t('label.freeSale');
      },
      isFreeSale() {
        return (this.purchaseTotal > 0);
      },
      hasProducts() {
        return (this.purchaseItems > 0);
      },
    },
  };
</script>
<style lang="stylus">
  .footer-bar,.footer-title
    height:80px!important
  .footer-title
    display: flex
    align-items : center !important
    justify-content : flex-start

  .SimpleLine
    display:flex
    flex-direction:column
    align-items : center;
    justify-content : flex-start
    span
      font-size:11px

</style>
